import React, { useContext, useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import OnDemandTypeSelector from "../OnDemandTypeSelector"
import OnDemandTimePicker from "../OnDemandTypeSelector/TimePicker"
import * as styles from "./styels.module.less"
import { addBusinessDays, format, parse } from "date-fns"
import minDateGap from "../../utils/minDateGap"
import { SpaceProfileContext } from "../SpaceProfile/context"

export default ({
  setParentStartDate = () => null,
  setParentEndDate = () => null,
  setParentStartTime = () => null,
  setParentEndTime = () => null,
  setTempStartDate = () => null,
  isDaily = true,
  setIsDaily = () => null,
  startD,
  endD,
  startT,
  endT,
  ...props
}) => {
  const {
    commonData: { holidays },
  } = useContext(SpaceProfileContext)

  const [startDate, setStartDate] = useState(startD)
  const [startTime, setStartTime] = useState(startT)
  const [endDate, setEndDate] = useState(endD)
  const [endTime, setEndTime] = useState(endT)

  useEffect(() => {
    if (startDate) setParentStartDate(startDate)
    if (endDate) setParentEndDate(endDate)
    if (startTime && endTime) {
      setParentStartTime(startTime)
      setParentEndTime(endTime)
    }
  }, [endDate, endTime])

  const updateDate = (dates) => {
    if (dates.length && dates.length === 2) {
      const [start, end] = dates
      setStartDate(start)
      setTempStartDate(!end ? start : null)
      setEndDate(end)
    } else {
      setStartDate(dates)
    }
  }

  const setToDaily = (value) => {
    setStartDate(null)
    setEndDate(null)
    setIsDaily(value)
    if (value) {
      setStartTime("")
      setEndTime("")
    }
  }

  useEffect(() => {
    if (!isDaily && !startD) {
      const today = parse(
        `${format(new Date(), "yyyy-MM-dd")} 0:00:00`,
        "yyyy-MM-dd H:mm:ss",
        new Date()
      )
      setStartDate(addBusinessDays(today, minDateGap()) || new Date())
    }
  }, [isDaily])

  return (
    <div className={styles.date_time_picker}>
      <div>
        <OnDemandTypeSelector
          isDaily={isDaily}
          setDaily={() => setToDaily(true)}
          setHourly={() => setToDaily(false)}
          className={"mb-1"}
        />
        <DatePicker
          selected={startDate}
          minDate={addBusinessDays(new Date(), minDateGap()) || new Date()}
          onChange={updateDate}
          startDate={startDate}
          endDate={endDate}
          selectsRange={isDaily}
          inline
          showPopperArrow={false}
          excludeDates={holidays}
        />
        {isDaily && !startDate && <p>Please select a start date</p>}
        {isDaily && startDate && !endDate && <p>Please select an end date</p>}
        {!isDaily && !startDate && <p>Please select a date</p>}
      </div>
      {!isDaily && (
        <OnDemandTimePicker
          startDate={startDate}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
        />
      )}
    </div>
  )
}
